<template>
  <div>
    <img
      class="d-none d-sm-none d-md-none d-lg-none d-xl-inline-block"
      src="../assets/My-GDQ-Management.svg"
      width="400"
    />
    <img
      class="d-none d-sm-inline-block d-md-inline-block d-lg-inline-block d-xl-none"
      src="../assets/My-GDQ-Management.svg"
      width="340"
    />
    <img
      class="d-inline-block d-sm-none d-md-none d-lg-none"
      src="../assets/GDQ-White.svg"
      width="100"
    />
    &nbsp;
    <span
      v-if="gdqmodetext !== ''"
      class="badge gdq-mode-badge d-none d-sm-inline"
    >
      {{ gdqmodetext }}
    </span>
    <span
      v-if="asadmin === 1"
      class="badge gdq-mode-badge d-none d-sm-inline ms-1"
    >
      A
    </span>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { config } from "../../config";

const store = useStore();
const asadmin = computed(() => store.state.asadmin);

const gdqmodetext = ref(
  config.mode === "live" ? "" : config.mode === "stage" ? "Stage" : "Dev"
);
</script>

<style scoped>
.gdq-mode-badge {
  background-color: #ff0000;
  color: #ffffff;
}
</style>
